/**
 * Validates the divesite form data.
 * @param {Object} formState - The current form state.
 * @returns {string|null} - An error message string if validation fails, otherwise null.
 */
export const validateForm = (formState) => {
  // 1. Basic Information Validation
  if (!formState.name.trim()) {
    return "Please provide a name for the divesite.";
  }
  if (!formState.environment.trim()) {
    return "Please select the environment (e.g., ocean, lake, quarry).";
  }
  if (!formState.platform.trim()) {
    return "Please select the primary platform for diving (e.g., shore, boat).";
  }

  // 2. Location Validation
  // Ensure location string is present AND marker coordinates are set
  if (
    !formState.location.trim() ||
    !formState.markerPosition ||
    typeof formState.markerPosition.lat !== "number" ||
    typeof formState.markerPosition.lng !== "number"
  ) {
    return "A valid location must be provided and marked on the map.";
  }

  // 3. Depth Range Validation
  if (
    !Array.isArray(formState.depthRange) ||
    formState.depthRange.length !== 2 ||
    typeof formState.depthRange[0] !== "number" ||
    typeof formState.depthRange[1] !== "number"
  ) {
    return "Depth range must be specified.";
  }
  if (formState.depthRange[0] >= formState.depthRange[1]) {
    return "Minimum depth must be less than maximum depth.";
  }
  if (formState.depthRange[0] < 0 || formState.depthRange[1] < 0) {
    return "Depth values cannot be negative.";
  }

  // 4. Photo Copyright Agreement (if applicable, ensure this field exists in your formState)
  // Assuming 'photosUploadedAndAgreed' is a boolean checkbox
  if (
    formState.mediaImages &&
    formState.mediaImages.length > 0 &&
    !formState.photosUploadedAndAgreed
  ) {
    return "You must agree to the photo copyright terms before submitting images.";
  }

  // All checks passed
  return null;
};
